import * as React from "react"
import markerImage from "../../../../../images/marker.svg"

export const Marker = (props) => {
  return (
    <div className="marker-container">
      <img className="marker" src={markerImage} />
    </div>
  );
};



// WEBPACK FOOTER //
// ./src/share/components/Maps/Map/components/Marker.tsx